import Preview from '../Preview'
import FieldEdit from '../FieldEdit'
import EmailToTarget from './EmailToTarget'

export default function EmailToTargetActionView({ actionId }) {
    const templateFields = useSel(s => s.builder.flow.templateFields)
    const flowFields = useSel(s => s.builder.flow.flowFields)
    const selectedActionId = useSel(s => s.local.selectedActionId)
    const config = useSel(s => s.actions.entities[selectedActionId]?.config || {})
    const context = { template: templateFields, embedUrl: config?.embedUrl, flow: { ...flowFields, current_action_kind: 'email_to_target' }, client: { brand: JSON.parse(window.ENV.CLIENT_BRAND) } }
    const action = useSel(s => s.actions.entities[actionId] || {})
    const isDirty = useSel((s) => s.local.isDirty)

    const componentMap = useMemo(() => ({
        TakeSurveyForm: <EmailToTarget
            action={action}
            onSubmit={() => Promise.resolve()}
        />,
        FieldEdit,
    }), [JSON.stringify(config)])

    return <>
        {action.kind === 'email_to_target' && isDirty &&
            <div className='alert'>Changes to templates or recipients won't display here until you save.</div>
        }
        <Preview context={context} componentMap={componentMap} />
    </>

}
